// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type CheckoutReceipts } from '@tectonics/prs/receipts';

export function getReceipts(incomingPayment: IncomingPayment): CheckoutReceipts {
  if (!incomingPayment['checkout_receipts'])
    throw new Error('getReceipts: there is no "checkout_receipts" in the incoming payment');

  return incomingPayment['checkout_receipts'];
}
